import formatPrice from "../formatPrice";
import content from "app-content";
const {
  saved_items_accessibility_original_price,
  generic_current_price: currentPriceLabel,
  saved_items_accessibility_price: priceLabel,
  saved_items_from_price: fromLabel,
  generic_price_rrp
} = content;

const getItemPriceAriaLabel = ({
  priceInfo: { currentPrice, originalPrice, isDiscounted, isOutlet },
  hasMultiplePricesInStock,
  variantId
}) => {
  const currentPriceString = `${
    hasMultiplePricesInStock && variantId === null ? `${fromLabel} ` : ""
  }${formatPrice(currentPrice)}`;

  if (isDiscounted) {
    const originalPriceLabel = isOutlet
      ? generic_price_rrp
      : saved_items_accessibility_original_price;

    return `${originalPriceLabel}: ${formatPrice(
      originalPrice
    )}, ${currentPriceLabel}: ${currentPriceString}`;
  }

  return `${priceLabel}: ${currentPriceString}`;
};

export default getItemPriceAriaLabel;
